import React from "react";
//#region types
import { CreditInvoiceBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Banner, StyledButton } from "components/common";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const CreditInvoiceBanner: React.FC<CreditInvoiceBannerProps> = (props) => {
  const { invoice, displayType } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const onClicked = () => {
    navigate(UrlHelper.formatPath(`/Invoice/${invoice.creditedInvoiceId}`), {
      state: { background: location },
    });
  };

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreditInvoice)}
      icon={IconDefinitionConstants.WMoney}
      type={displayType}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreditInvoiceDescription)}
        </Grid>
        {invoice.creditedInvoiceId ? (
          <Grid item>
            <StyledButton size="sm" displayType={displayType} onClick={onClicked}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ViewOriginalInvoice)}
            </StyledButton>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Banner>
  );
};

export default CreditInvoiceBanner;
